export const cilFont = ["24 24","<path d='M9.003 15.516h5.995l1.129 2.859h2.721l-5.236-13.266h-3.222l-5.236 13.266h2.721zM12 7.922l1.998 5.062h-3.997z'></path><path d='M0.75 0.75v22.5h22.5v-22.5zM21.75 21.75h-19.5v-19.5h19.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-font.js
// module id = null
// module chunks = 